<section id="content-signature" class="row signature">
  <div class="col-12">
    <h3 class="h-main h-main-medium corporate">{{ 'signature_title' | translate }}</h3>
    <div class="primary-info-box highlight">
      <div class="col-12">
        <div class="row date-row">
          <p class="info-text">{{ 'signature_info_1' | translate }}</p>

          <p class="info-text">{{ 'signature_info_2' | translate }}</p>

          <p class="info-text">{{ 'signature_info_3' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12"></div>
</section>

<section class="row appraisal-info">
  <div class="col-12">
    <h3 class="h-main h-main-medium corporate">{{ 'signature_data' | translate }}</h3>
  </div>
  <div class="col-12">
    <div class="primary-info-box">
      <div class="row date-row">
        <div class="col-4 col-md-6 text-align-left">
          <h3 class="amount">{{ 'signature_agency' | translate }}</h3>
        </div>
        <div class="col-8 col-md-6">
          <h3 class="amount">{{ signature?.mortgagesSignCrmData?.mortgageNotaryData?.notaryName }}</h3>
        </div>
      </div>
      <div class="row date-row">
        <div class="col-4 col-md-6 text-align-left">
          <span> {{ 'signature_notary_assigned' | translate }} </span>
        </div>
        <div class="col-8 col-md-6">
          <span
            >{{ signature?.mortgagesSignCrmData?.mortgageNotaryData?.name }}
            {{ signature?.mortgagesSignCrmData?.mortgageNotaryData?.firstSurname }}
            {{ signature?.mortgagesSignCrmData?.mortgageNotaryData?.secondSurname }}</span
          >
        </div>
      </div>
      <div class="row date-row">
        <div class="col-4 col-md-6 text-align-left">
          <span>{{ 'signature_address' | translate }}</span>
        </div>

        @if (signature?.mortgagesSignCrmData?.mortgageNotaryData?.notaryAddress) {
          <div class="col-8 col-md-6">
            <span> {{ address }} </span>
          </div>
        }
      </div>
      <div class="row calendar-row">
        <div class="col-12">
          <h3 class="h-main h-main-medium text-center">{{ 'signature_date' | translate }}</h3>
          <span class="ic ic-calendar2"></span>

          @if (signature?.mortgagesSignCrmData?.signatureDate) {
            <span>{{ signature?.mortgagesSignCrmData?.signatureDate | date: "d 'de' MMMM y" }}</span>
          }
          @if (signature?.mortgagesSignCrmData?.signatureTime) {
            <span>{{ signature?.mortgagesSignCrmData?.signatureTime.substr(0, 5) }} h</span>
          }
        </div>
      </div>
      <div class="row date-row">
        @if (!mapError) {
          <div class="col-12">
            <h3 class="h-main h-main-medium text-center">{{ 'signature_location_agency' | translate }}</h3>
          </div>
        }
        <div class="col-12 map">
          <div [hidden]="mapError" id="map" class="sign-map"></div>
        </div>
      </div>
    </div>
  </div>
</section>
